'use client';
import { featureFlags } from '@lib/constants/network-constants';
import { getFeatureFlagState } from '@lib/data';
import { getLogger } from '@lib/util/logging-util';
import { useEffect } from 'react';

const GOOGLE_RECAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js';
const GoogleRecaptcha = () => {
    const logger = getLogger();

    const checkGoogleRecaptchaEnabled = async (): Promise<boolean> => {
        try {
            return await getFeatureFlagState(featureFlags.ENABLE_GOOGLE_CAPTCHA);
        } catch (error) {
            logger.critical('Error checking Google Recaptcha state:', error);
            return false;
        }
    };

    const addGoogleRecaptchaScript = () => {
        if (document.querySelector(`script[src="${GOOGLE_RECAPTCHA_SCRIPT_URL}"]`)) {
            logger.debug('Google Recaptcha script is already added');
            return;
        }

        const scriptElem = document.createElement('script');
        scriptElem.setAttribute('src', GOOGLE_RECAPTCHA_SCRIPT_URL);
        scriptElem.async = true;
        scriptElem.type = 'text/javascript';

        scriptElem.onload = () => {
            logger.debug('Google Recaptcha script loaded successfully');
        };

        scriptElem.onerror = () => {
            logger.error('Failed to load Google Recaptcha script');
        };

        document.head.appendChild(scriptElem);
    };
    useEffect(() => {
        const initializeGoogleRecaptcha = async () => {
            const enabled = await checkGoogleRecaptchaEnabled();
            if (enabled) {
                addGoogleRecaptchaScript();
            }
        };

        initializeGoogleRecaptcha();
    }, []);

    return null;
};

export default GoogleRecaptcha;
